import { TQuery, TQueryConstructor } from '@hozana/api/types'
import { normalize } from '@hozana/redux/normalize'

import entities from 'config/entities'

import { TPrayerEvent } from './types'

export type TPrayerEventIdOnlyProp = { prayerEventId: number }
export const getPrayerEventQuery: TQueryConstructor<TPrayerEventIdOnlyProp, number> = ({ prayerEventId }): TQuery => ({
  queryKey: `getPrayerEvent/${prayerEventId}`,
  url: `/prayer-event/${prayerEventId}`,
  normalize: (data: TPrayerEvent) => normalize(data, entities.prayerEvent),
})
